import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson5: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center p-[2.69rem] box-border gap-[6.88rem] text-left text-[1.88rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between text-[1.56rem]">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson4"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Mind Conditioning
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson6"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[6.25rem] text-justify text-white font-dm-sans">
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>What is Conditioning?</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  If you want to become the master of your mind, you have to
                  understand how your conditioning came about. Conditioning
                  shapes you as a person. It determines your thinking patterns
                  and the beliefs you believe in. In science, conditioning is
                  also called a paradigm: a complex set of beliefs, a frame of
                  reference from which you interpret the world around you. It is
                  a filter through which you absorb, colour, and organize
                  information. We all look at the world around us through our
                  own unique filters. It shapes your frame of mind and thus your
                  image of the reality you believe in.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[27.38rem] h-[30.19rem] object-cover"
            alt=""
            src="/6@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Does Conditioning Work?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                How conditioning works and how your thought patterns emerge is
                easily explained by comparing yourself to a new computer with no
                operating system. Its hard disk and working memory are empty.
                From the moment you are brought to life, all outside impressions
                are stored. This process starts in the womb and accelerates from
                birth onwards. Especially in your early years, you are in a pure
                state of consciousness because you do not yet have any
                experiences to which you can refer. You store all the
                information you receive, all the things you hear, see, feel and
                experience.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The hard disk (your subconscious) gradually fills up with
                hundreds of thousands of stored files (experiences, learning
                moments, information, feelings, thoughts) and new software
                programs (skills). the whole thing forms your frame of
                reference. On this basis, your personal operating system begins
                to form itself. You can think of it as a software program
                consisting of countless thought patterns and an accumulation of
                habits.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You receive both correct and incorrect information but you do
                not know how to differentiate what you store. Your system
                contains basic errors. As a result, your hard disk is programmed
                with countless incorrect data. And each time new corrupt files
                and viruses invade the domain of the hard disk. but you are so
                convinced of your own truth that you don't realize this.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                What happens to a computer whose operating system has basic
                errors? it needs an update. But the system doesn't allow you to
                deviate from that programmed software. The moment you do try, it
                will do everything in its power to get you back in line. You
                have to break through that resistance to change the software in
                your operating system. Your conditioning is a mental program
                that almost exclusively controls your behavior, how you think,
                what you do, how you react, and how you feel.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>How Can You Change Your Conditioning?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You can change your conditioning. This is a matter of being
                aware of what you are doing and discovering what you can change
                best to get a different outcome. If you don't succeed, then
                change something each time to get a different outcome. Keep
                changing your approach until you get the desired outcome. If you
                want to change something about yourself, your behavior, or your
                existence, you will have to rewrite your story and your
                operating system. And in this new story, you must not only
                believe but you must also really be convinced of it deep inside.
                However, it is not as easy as it sounds. You want to change
                yourself, but this simply doesn't work. Why is this?
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Because your operating system won't allow it. It doesn't want
                  to be overwritten by an update. it's a long-standing, deeply
                  ingrained pattern. That pattern features a five-lane highway
                  or the easy way. The new pattern has to create its own new
                  forest path. Certainly not so easy at first.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Because you don't really want it. You are pretending, but you
                  are fooling yourself. you are unable to program your software
                  update. you lack desire, need, self-discipline, perseverance,
                  and willpower. If you really want something, you do it. No
                  excuses, no fiddling, no excuses.
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                So, how do you change your conditioning? What really matters is
                that it takes almost no effort on your part when you really want
                something. How big is your desire? Or is there a need? the
                choice is yours to do something or not. It is your
                responsibility. Wishing and hoping is what you do in fable land.
                wishing and wanting are not enough. Lots of people 'want' all
                sorts of things, but very little comes of it. Make your want-to
                a have-to! If you have to, you will do it.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To achieve lasting change, it is important to start by
                addressing the things that can be changed immediately. Deciding
                to change does not take time, but procrastinating or avoiding
                change can waste time. The more strongly you desire or need
                change, the less discipline, willpower, and perseverance you
                will need. Remember that you are responsible for your own
                behaviour, and taking responsibility, regardless of the
                circumstances, gives you control over your own life and personal
                leadership. It is important to live according to your own rules
                and values.
              </span>
            </span>
          </p>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson6"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson5;
